import React from 'react';
import { DynamicFeed, Equalizer, Mood } from '@mui/icons-material';
import { AppIcon } from './AppIcon';
import { AppName, AppUrls, BoneLink } from './types';

const APP_URLS: AppUrls = {
  [AppName.Authors]: 'https://one-web.prismamedia.com/#/authors/list',
  [AppName.Crud]: 'https://one-web.prismamedia.com/#/crud',
  [AppName.Diapo]: 'https://one-web.prismamedia.com/#/slideshow/list',
  [AppName.Newsletter]: 'https://newsletter.prismamedia.com/',
  [AppName.People]: 'https://one-people.prismamedia.com/',
  [AppName.Photo]: 'https://photos.prismamedia.com/',
  [AppName.Recipe]: 'https://one-recipe.prismamedia.com/',
  [AppName.Story]: 'https://topic.prismamedia.com/',
  [AppName.Video]: 'https://one-web.prismamedia.com/#/video/list',
  [AppName.Web]: 'https://one-web.prismamedia.com/#/article/list',
};

export const getMenuHref = (
  appName: AppName,
  overriddenAppUrls?: Partial<AppUrls>,
): string | undefined => ({ ...APP_URLS, ...overriddenAppUrls }[appName]);

export const getAppLink = (
  appName: AppName,
  overriddenAppUrls?: Partial<AppUrls>,
): BoneLink => ({
  href: getMenuHref(appName, overriddenAppUrls),
  label: appName,
  icon: <AppIcon appName={appName} />,
  openBlank: true,
});

export const getAppLinks = (
  appName: AppName,
  overriddenAppUrls?: Partial<AppUrls>,
): BoneLink[] => {
  switch (appName) {
    case AppName.Web:
    case AppName.Diapo:
    case AppName.Video:
    case AppName.Crud:
      return [
        AppName.Photo,
        AppName.Story,
        AppName.Recipe,
        AppName.Newsletter,
        AppName.People,
      ].map((app) => getAppLink(app, overriddenAppUrls));

    default:
      return [
        AppName.Web,
        AppName.Photo,
        AppName.Story,
        AppName.Recipe,
        AppName.Diapo,
        AppName.Newsletter,
        AppName.People,
      ]
        .filter((app) => app !== appName)
        .map((app) => getAppLink(app, overriddenAppUrls));
  }
};

export const toolsLinks: BoneLink[] = [
  {
    label: 'Suite One',
    href: 'https://sites.google.com/prismamedia.com/suite-one/accueil',
    icon: <Mood />,
    openBlank: true,
  },
  {
    label: 'Google Analytics',
    href: 'https://www.google.com/analytics/',
    icon: <Equalizer />,
    openBlank: true,
  },
  {
    label: 'Parse.ly',
    href: 'https://dash.parsely.com/',
    icon: <DynamicFeed />,
    openBlank: true,
  },
];
